export default __webpack_public_path__ + "static/media/circle-white.e1614a4f.svg";